"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
exports.ARIA_LIVE_DELAY = new core_1.InjectionToken('live announcer delay');
exports.DEFAULT_ARIA_LIVE_DELAY = 100;
function createLiveElement(document) {
    var element = document.createElement('div');
    element.setAttribute('aria-live', 'polite');
    element.setAttribute('aria-atomic', 'true');
    element.classList.add('sr-only');
    document.body.appendChild(element);
    return element;
}
var Live = /** @class */ (function () {
    function Live(document, _delay) {
        this._delay = _delay;
        this._element = createLiveElement(document);
    }
    Live.prototype.ngOnDestroy = function () { this._element.parentElement.removeChild(this._element); };
    Live.prototype.say = function (message) {
        var element = this._element;
        var delay = this._delay;
        element.textContent = '';
        var setText = function () { return element.textContent = message; };
        if (delay === null) {
            setText();
        }
        else {
            setTimeout(setText, delay);
        }
    };
    Live = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject(common_1.DOCUMENT)), __param(1, core_1.Inject(exports.ARIA_LIVE_DELAY)),
        __metadata("design:paramtypes", [Object, Number])
    ], Live);
    return Live;
}());
exports.Live = Live;
//# sourceMappingURL=live.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/util/accessibility/live.js
// module id = 79
// module chunks = 0